import { REFINEMENT_DIMENSION } from '~/shared/constants'
import type { GalleryModelsUrl } from 'shared/types/gallery/models'
import type { Refinements } from '~/app/store/refinement/interface'

export const excludeRefinement = (refinements: Refinements, refinementToExclude: REFINEMENT_DIMENSION): GalleryModelsUrl.RefinementItem[] => {
  const filteredRefinements = []

  for (const key in refinements) {
    if (Object.hasOwn(refinements, key) && refinements[key].dimension !== refinementToExclude) {
      filteredRefinements.push(refinements[key])
    }
  }
  return filteredRefinements
}
